import { useFeatureFlag } from '@src/hooks';
import {
  ButtonVariants,
  FormControlSizes,
  IconName,
  MenuItem,
  MixpanelEvent,
  NavButton,
  Popover,
  Stack,
  useDisclosure,
  useMixpanel,
  usePopoverState,
} from '@talos/kyoko';
import { useCallback } from 'react';
import { SupportTicketDialog } from '../../components/SupportTicket/SupportTicketDialog';
import { envConfig } from '../../utils/envConfig';
import { HeaderButton } from './HeaderButton';

const POPOVER_TARGET_STYLE = { height: '100%' };

export function SupportMenuButton({ compact = false }: { compact?: boolean }) {
  const mixpanel = useMixpanel();
  const { enableSupportModal } = useFeatureFlag();
  const supportTicketDialog = useDisclosure();

  const supportMenu = usePopoverState({
    placement: 'bottom-start',
    closeOnClickOutside: true,
    noPaddingAndBorder: true,
    trigger: 'click',
  });

  const handleSupportTicketClick = useCallback(() => {
    mixpanel.track(MixpanelEvent.SupportTicket);
    supportTicketDialog.open();
  }, [supportTicketDialog, mixpanel]);

  return (
    <>
      <Popover {...supportMenu} targetStyle={POPOVER_TARGET_STYLE}>
        <HeaderButton
          size={FormControlSizes.Small}
          onClick={() => supportMenu.open()}
          borderPlacement="left"
          startIcon={IconName.Support}
          variant={supportMenu.isOpen ? ButtonVariants.Priority : ButtonVariants.Default}
          compact={compact}
          data-testid="header-button-help"
          dim
        >
          Help
        </HeaderButton>

        <Stack>
          {enableSupportModal && (
            <MenuItem ghost onClick={handleSupportTicketClick} startIcon={IconName.Ticket} id="talos-support-ticket">
              Support Ticket
            </MenuItem>
          )}
          <NavButton
            startIcon={IconName.BookOpen}
            to={envConfig.VITE_KNOWLEDGE_BASE_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              mixpanel.track(MixpanelEvent.KnowledgeBase);
              mixpanel.track(MixpanelEvent.OpenKnowledgeBase);
            }}
            ghost
          >
            Knowledge Base
          </NavButton>
        </Stack>
      </Popover>
      <SupportTicketDialog dialog={supportTicketDialog} />
    </>
  );
}
